// extracted by mini-css-extract-plugin
module.exports = {"root":"SnackbarList_root__8B_bQ","list":"SnackbarList_list__BV7U2 list-reset cy-3 py-6"};